<script lang="ts">
  import { dev } from '$app/environment';
  import { onMountMoveDynamicStyles } from '$lib/helpers/dynamic-css-helpers';

  if (dev) {
    onMountMoveDynamicStyles();
  }
</script>

<slot />
